// src/pages/Accounting/Reconcile/components/RefresherLink.tsx

import type React from "react";
import { useState } from "react";
import { PALETTE } from "../constants";
import { VelaIntroBlock } from "./VelaIntroBlock";

export function RefresherLink() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={{ marginBottom: expanded ? 0 : 20 }}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        style={linkStyle}
      >
        <span style={vDotStyle} aria-hidden="true">
          V
        </span>
        {expanded ? "Hide intro" : "What does Vela do here?"}{" "}
        {expanded ? "\u2191" : "\u2192"}
      </button>
      {expanded && (
        <div style={{ marginTop: 14 }}>
          <VelaIntroBlock />
        </div>
      )}
    </div>
  );
}

const linkStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  fontSize: 12.5,
  color: PALETTE.velaDeep,
  fontWeight: 600,
  cursor: "pointer",
  padding: 0,
  background: "transparent",
  border: 0,
};

const vDotStyle: React.CSSProperties = {
  width: 16,
  height: 16,
  borderRadius: "50%",
  background: PALETTE.vela,
  color: "#fff",
  fontWeight: 700,
  fontSize: 9,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};